import { useState } from "react";
import LoadingSpinner from "src/components/Loader/LoadingSpinner";
import useGetStacks from "src/hooks/useGetStacks";
import { useClientSignUpSteps } from "src/lib/store/hirer-steps-store";
import { StepStyleSection } from "../../layout";
import ErrorBox from "../../components/ErrorBox";
import { CheckboxItem } from "../../components/check/checkbox";
import { InfoIcon } from "lucide-react";


export default function SelectType({ }) {
  const { loading, error, stacks, retry } = useGetStacks();
  const { userStack, userJobType, updateUserJobType, updateUserFrameworks,
    updateUserStack
   } = useClientSignUpSteps();

  const isCustomStack = userStack && stacks && stacks.length > 0 && !stacks.some(s => s.id === userStack);

  const [showOtherInput, setShowOtherInput] = useState(userStack === 'other' || isCustomStack);

  return (
    <StepStyleSection >
      <>
        <div className="flex flex-col gap-4">

          <div className="flex w-full items-center gap-4">
            <p className="text-semibold">Select Job Type</p>
          </div>

          {loading && <LoadingSpinner />}

          {error && <ErrorBox message={`${error}`} onRetry={retry} />}
          
          {!loading && !error && (
            <div className="flex flex-wrap gap-2">
              <CheckboxItem
                selected={userJobType === 'tech'}
                onSelect={() => {
                  updateUserJobType('tech');
                  setShowOtherInput(false);
                  updateUserStack(undefined);
                  updateUserFrameworks([])
                }}
              >
                Tech Role
              </CheckboxItem>

              <CheckboxItem
                selected={userJobType === 'non-tech'}
                onSelect={() => {
                  updateUserJobType('non-tech');
                  setShowOtherInput(false);
                  updateUserStack('non-tech');
                  updateUserFrameworks([])
                }}
              >
                Non-Tech Role
              </CheckboxItem>
            </div>
          )}

    
        </div>
      </>
    </StepStyleSection>
  );
}
